import { Ref } from "@tblabs/truffle";
import { Product } from "../../Models/Product/Product";
import { QuantityDiscountCalculator } from "../QuantityDiscountCalculator";
import { Basket } from "./Basket";
import { BasketItem } from "./BasketItem";
import { BasketItemType } from "../../Models/Basket/BasketItemType";
import { SaleBasketStorageItem } from "./Storage/BasketStorageItem";


export class SaleBasketItem extends BasketItem
{
    constructor(
        private basket: Basket,
        public Product: Product | undefined,
        public ProductOptionId: Ref<string>,
        public Quantity: Ref<number>)
    {
        super(BasketItemType.Sale, Product, ProductOptionId, Quantity, basket.Discounter);

        this.UpdateOnInputChange();
    }

    public UpdateOnInputChange(): void
    {
        if (!this.Product)
            return;
        
        const quantity = this.Quantity.value;
        const salePrice = this.Product.SalePrice.value;
        const discounts = this.Product.Discounts.Items.map(x => ({ quantity: x.Quantity.value, discountPercent: x.Percent.value }));
        const { discountMultiplier, discountPercent } = QuantityDiscountCalculator.Calc(discounts, quantity);
        const optionFactor = this.Product.Options.GetPriceFactor(this.ProductOptionId.value);
        const generalFactor = this.basket.Config.GeneralPriceFactor.value;

        this.FinalPriceBeforeDiscount.value = +(quantity * salePrice * optionFactor * generalFactor).toFixed(0);
        // const otherDiscountsPercent = this.Discounter.GetTotalPercent();
        // const otherDiscountsMultiplier = 1 - otherDiscountsPercent / 100;
        const otherDiscountsValue = this.Discounter.GetTotalValue(this.FinalPriceBeforeDiscount.value);
        // this.FinalPriceAfterDiscount.value = +(this.FinalPriceBeforeDiscount.value * discountMultiplier * otherDiscountsMultiplier).toFixed(0);
        this.FinalPriceAfterDiscount.value = +(this.FinalPriceBeforeDiscount.value * discountMultiplier - otherDiscountsValue).toFixed(0);
        this.Label.value = `Zakup`;
        this.QuantityDiscountPercent.value = discountPercent;

        this.onChangeHandlers.Call();
    }

    public AsRaw(): SaleBasketStorageItem | undefined
    {
        if (!this.Product)
            return undefined;

        return ({
            Type: BasketItemType.Sale,
            ProductId: this.Product.Id,
            ProductOptionId: this.ProductOptionId.value,
            Quantity: this.Quantity.value,
        });
    }
}
